window.teamPage = function() {
    const sortLatter = () => {
        $(".sort").click(function () {
            $(this).toggleClass("active").siblings().removeClass("active");

            let charachter = $('.button.authorSort__btn.active').data('value'),
                latterAll = $('#latterAll');

            window.sortFirstLetters(latterAll, charachter);
        });

        window.sortFirstLetters = function(elem, charachter) {
            const position = $('.sort.active').data('filter')
            let url = window.location.href.split('?')[0];
                url += '?page=1';
        
            $.ajax({
                url: url,
                dataType: 'html',
                type: "POST",
                data: {
                    terms: charachter,
                    position: position
                },
            })
            .done(function(response) {
                $('.authorSort__btn').removeClass('active');
                $(elem).addClass('active');
        
                $('#list-ajax').html(response);
                $('html, body').animate({
                    scrollTop: $("#list-ajax").parent().parent().offset().top
                }, 1000);
        
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1';  
                window.history.pushState({ path: refresh }, '', refresh);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                console.log(errorThrown);
            });
        }
    };

    const paginate = () => {
        $(document).on('click', '#pagination-author-list a', function(event) {
            let charachter = $('.button.authorSort__btn.active').data('value');

            let url = $(this).attr('href');
            window.history.pushState({}, null, url);

            $.ajax({
                type: 'POST',
                url: url,
                data: { 
                    terms: charachter
                },
                success:function(response) {
                    $('#list-ajax').html(response);
                    $('html, body').animate({
                        scrollTop: $("#list-ajax").parent().parent().offset().top
                    }, 1000);
                }
            });
            
            return false;
        })
    };
    
    return {
        init: function() {
            sortLatter();
            paginate();
        }
    };
}();

window.detailPage = function() {
    const init = () => {};
    
    return {
        init: function() {
            init();
        }
    };
}();